/* IronGrind – shipping protection toggle for the Yuva cart drawer + cart page.
   Config comes from the "IGA shipping protection" section (footer group).
   - Keeps exactly one protection line in the cart, priced by the merchandise subtotal tier.
   - Default on (configurable); the shopper's opt-out is remembered in localStorage.
   - Hides the protection line from the item list and shows it as a toggle above checkout instead.
*/
(function () {
  var cfgEl = document.getElementById('IgaProtectionConfig');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!C.enabled || !C.variants || !C.tiers || !C.tiers.length) return;

  var OPT_OUT = 'iga_protection_optout';
  var OPT_IN = 'iga_protection_optin';
  var ids = {};
  Object.keys(C.variants).forEach(function (k) { ids[Number(C.variants[k])] = true; });
  var handlePath = '/products/' + C.handle;
  var lastCart = null;
  var busy = false;

  function store(k, v) { try { if (v) { localStorage.setItem(k, '1'); } else { localStorage.removeItem(k); } } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k) === '1'; } catch (e) { return false; } }
  function wanted() { return C.defaultOn ? !read(OPT_OUT) : read(OPT_IN); }
  function isProt(item) { return !!ids[item.variant_id] || item.product_type === 'ship_protect' || (item.url || '').indexOf(handlePath) === 0; }
  function merchOf(cart) { return cart.items.filter(function (i) { return !isProt(i); }); }
  function subtotal(cart) { return merchOf(cart).reduce(function (s, i) { return s + (i.final_line_price || 0); }, 0); }
  function tierPrice(cents) {
    for (var t = 0; t < C.tiers.length; t++) { if (cents < C.tiers[t][0] * 100) return C.tiers[t][1]; }
    return C.tiers[C.tiers.length - 1][1];
  }
  function targetVariant(cents) { return Number(C.variants[Number(tierPrice(cents)).toFixed(2)] || 0); }
  function money(cents) {
    try {
      /* global moneyFormat */
      var fmt = typeof moneyFormat !== 'undefined' ? moneyFormat : window.moneyFormat;
      if (window.Shopify && Shopify.formatMoney && fmt) return Shopify.formatMoney(cents, fmt);
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }
  function view(cart) {
    var merch = merchOf(cart);
    var v = {};
    for (var k in cart) { v[k] = cart[k]; }
    v.items = merch;
    v.item_count = merch.reduce(function (s, i) { return s + i.quantity; }, 0);
    return v;
  }
  function setCount(cart) {
    var n = view(cart).item_count;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n > 0 && n < 100 ? n : '';
      el.style.display = n > 0 ? '' : 'none';
    });
    document.querySelectorAll('[data-cart-item-count]').forEach(function (el) { el.textContent = n; });
  }

  function reconcile(cart) {
    var prot = cart.items.filter(isProt);
    var merch = merchOf(cart);
    var want = merch.length > 0 && wanted();
    var target = want ? targetVariant(subtotal(cart)) : 0;
    if (want && !target) want = false;
    var fine = want
      ? (prot.length === 1 && prot[0].variant_id === target && prot[0].quantity === 1)
      : prot.length === 0;
    if (fine) return Promise.resolve(cart);
    var updates = {};
    prot.forEach(function (i) { updates[i.variant_id] = 0; });
    if (want) updates[target] = 1;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); }).catch(function () { return cart; });
  }

  function guarded(cart) {
    if (busy) return Promise.resolve(cart);
    busy = true;
    return reconcile(cart).then(function (c) { busy = false; lastCart = c; return c; }, function () { busy = false; return cart; });
  }

  function onCartPage() { return window.location.pathname.replace(/\/$/, '').split('/').pop() === 'cart'; }

  function wrap() {
    var origBuild = window.buildCart;
    var origPage = window.cartPageUpdate;
    if (typeof origBuild === 'function' && !origBuild.__iga) {
      window.buildCart = function (cart, show, el) {
        guarded(cart).then(function (c) { setCount(c); origBuild(view(c), show, el); });
      };
      window.buildCart.__iga = true;
      window.__igaOrigBuild = origBuild;
    }
    if (typeof origPage === 'function' && !origPage.__iga) {
      window.cartPageUpdate = function (cart) {
        guarded(cart).then(function (c) { setCount(c); origPage(view(c)); });
      };
      window.cartPageUpdate.__iga = true;
      window.__igaOrigPage = origPage;
    }
  }

  function rowHTML(cart) {
    var cents = subtotal(cart);
    var on = cart.items.some(isProt);
    var price = money(Math.round(tierPrice(cents) * 100));
    return '<label class="iga-protect__row">' +
      '<input type="checkbox" class="iga-protect__input" data-iga-protect ' + (on ? 'checked' : '') + ' aria-describedby="IgaProtectDesc">' +
      '<span class="iga-protect__switch" aria-hidden="true"></span>' +
      '<span class="iga-protect__text"><span class="iga-protect__title">' + C.title + ' <strong>' + price + '</strong></span>' +
      '<span class="iga-protect__desc" id="IgaProtectDesc">' + C.desc +
      (C.link ? ' <a href="' + C.link + '" target="_blank" rel="noopener">' + C.linkText + '</a>' : '') + '</span></span>' +
      '</label>';
  }

  function decorate() {
    var cart = lastCart;
    // hide protection lines in the drawer and on the cart page
    document.querySelectorAll('a[href^="' + handlePath + '"]').forEach(function (a) {
      var row = a.closest('.media-link') || a.closest('tr');
      if (row && !row.hasAttribute('data-iga-protect-line')) { row.setAttribute('data-iga-protect-line', ''); }
    });
    if (!cart) return;
    var hasMerch = merchOf(cart).length > 0;
    var anchors = [];
    document.querySelectorAll('[data-drawer-body] .checkout-btn').forEach(function (b) { anchors.push(b); });
    var cartBtn = document.getElementById('cartCheckout');
    if (cartBtn) anchors.push(cartBtn);
    anchors.forEach(function (btn) {
      var host = btn.parentElement;
      var box = host.querySelector(':scope > .iga-protect');
      if (!hasMerch) { if (box) box.remove(); return; }
      var html = rowHTML(cart);
      if (!box) {
        box = document.createElement('div');
        box.className = 'iga-protect';
        host.insertBefore(box, btn);
      }
      if (box.__html !== html) { box.innerHTML = html; box.__html = html; }
    });
  }

  var pending = false;
  var mo = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; decorate(); });
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-iga-protect]');
    if (!input) return;
    var on = input.checked;
    store(OPT_OUT, !on);
    store(OPT_IN, on);
    document.querySelectorAll('[data-iga-protect]').forEach(function (i) { i.disabled = true; });
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(guarded)
      .then(function (c) {
        setCount(c);
        if (onCartPage() && window.__igaOrigPage) { window.__igaOrigPage(view(c)); }
        else if (window.__igaOrigBuild) { window.__igaOrigBuild(view(c), true); }
        try { window.dispatchEvent(new CustomEvent('iga:protection', { detail: { on: on } })); } catch (err) {}
      });
  });

  function init() {
    wrap();
    mo.observe(document.body, { childList: true, subtree: true });
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var before = JSON.stringify(cart.items.filter(isProt).map(function (i) { return [i.variant_id, i.quantity]; }));
        return guarded(cart).then(function (c) {
          var after = JSON.stringify(c.items.filter(isProt).map(function (i) { return [i.variant_id, i.quantity]; }));
          setCount(c);
          decorate();
          if (before !== after && onCartPage() && window.__igaOrigPage) window.__igaOrigPage(view(c));
        });
      });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
